

























import { ZenyaDialogComponent, ZenyaDialogInjects } from "../../dialogs/ZenyaDialog.vue";
import { ReadConfirmation } from "../../../types/readconfirmation/readconfirmation";
import storeHelper from "../../../store/store-helper";
import { ConfirmationParameters } from "../../../store/modules/readList/read-list";

export default ZenyaDialogComponent.extend({
    inject: ZenyaDialogInjects,
    name: "ReadNextDocument",
    components: {},
    props: {
        title: String
    },
    data: function () {
        return {
            nextReadConfirmationItem: null as ReadConfirmation
        };
    },
    created() {
        this.nextReadConfirmationItem = this.getNextReadConfirmationDocument();
    },
    computed: {},
    methods: {
        getNextReadConfirmationDocument(): ReadConfirmation {
            let readList: ReadConfirmation[] = storeHelper.readListStore.list;
            let lastConfirmed: ConfirmationParameters = storeHelper.readListStore.lastConfirmed;
            if (readList == null || readList.length === 0) {
                this.goToTaskList();
                return null;
            }

            //find next unread item
            let readListLength: number = readList.length;
            let lastReadIndex: number = -1;

            if (lastConfirmed) {
                for (let i = 0; i < readListLength; i++) {
                    let rci: ReadConfirmation = readList[i];
                    if (
                        rci.read_confirmation_id == lastConfirmed.read_confirmation_id &&
                        rci.document.document_id == lastConfirmed.document.document_id
                    ) {
                        lastReadIndex = i;
                        break;
                    }
                }
            } else {
                lastReadIndex = -1;
            }

            let rci: ReadConfirmation;
            let endPosition: number;

            if (lastReadIndex == -1) endPosition = readListLength - 1;
            //stop at end of list
            else endPosition = lastReadIndex; //stop at last read item

            //Iterate readList starting with the first after the last read item, round-trip to the same item
            for (let i = (lastReadIndex + 1) % readListLength; i % readListLength !== endPosition; i++) {
                rci = readList[i % readListLength];

                if (!rci.confirmed) return rci;
            }

            //Nothing left to read

            this.goToTaskList();
            return null;
        },
        async gotoNextReadConfirmationDocument(): Promise<void> {
            this.$emit("close-read-dialog");
            this.$router.push({
                name: "ReadDocument",
                params: { documentId: this.nextReadConfirmationItem.document.document_id }
            });
        },
        async gotoReadList(): Promise<void> {
            this.$emit("close-read-dialog");
            this.$router.push({ name: "ReadList", params: { fromReadNextDocument: "true" } });
        },
        goToTaskList(): void {
            storeHelper.siteStore.setSnackBarMessage(this.$t("document.documentReadSuccessMessage").toString(), false);
            this.$router.push({ name: "Tasks" });
        }
    }
});
